import type { Locales } from '@/i18n/i18n-types';
import { ItemGroup } from '@/components/ui/item';
import {
  CenteredContent,
  CenteredContentLayout,
} from '@/layouts/centered-content.layout';
import { SidebarLayout } from '@/layouts/sidebar.layout';
import type { AudienceItem } from '@/components/audiences/audience-list-types';
import { AudienceListHeader } from '@/components/audiences/audience-list-header';
import { AudienceListItem } from '@/components/audiences/audience-list-item';
import { AudienceEmptyState } from '@/components/audiences/audience-empty-state';

export type { AudienceItem } from '@/components/audiences/audience-list-types';

interface AudiencesListPresenterProps {
  audiences: AudienceItem[];
  tenantSlug: string;
  locale: Locales;
}

export function AudiencesListPresenter({
  audiences,
  tenantSlug,
  locale,
}: AudiencesListPresenterProps) {
  return (
    <SidebarLayout className="!p-0">
      <CenteredContentLayout>
        {audiences.length > 0 && <AudienceListHeader tenantSlug={tenantSlug} />}

        <CenteredContent>
          {audiences.length === 0 ? (
            <AudienceEmptyState tenantSlug={tenantSlug} />
          ) : (
            <div className="min-w-0 pb-8 sm:pb-12">
              <ItemGroup className="gap-2">
                {audiences.map((audience) => (
                  <AudienceListItem
                    key={audience.id}
                    audience={audience}
                    tenantSlug={tenantSlug}
                    locale={locale}
                  />
                ))}
              </ItemGroup>
            </div>
          )}
        </CenteredContent>
      </CenteredContentLayout>
    </SidebarLayout>
  );
}
